import { createSlice } from "@reduxjs/toolkit";

const patientSlice = createSlice({
  name: "patient",
  initialState: {
    patientData: null,
    isGetPatientLoading: false,
    isUpdatePatientLoading: false,
    singlePatientData: null,
    isGetPatientByIdLoading: false,
  },
  reducers: {
    getPatientLoading: (state) => {
      state.isGetPatientLoading = true;
    },
    getPatientSuccess: (state, action) => {
      state.patientData = action.payload;
      state.isGetPatientLoading = false;
    },
    getPatientFailure: (state) => {
      state.isGetPatientLoading = false;
    },
    // update
    updatePatientLoading: (state) => {
      state.isUpdatePatientLoading = true;
    },
    updatePatientSuccess: (state, action) => {
      state.patientData = action.payload;
      state.isUpdatePatientLoading = false;
    },
    updatePatientFailure: (state) => {
      state.isUpdatePatientLoading = false;
    },
    // get by id
    getPatientByIdLoading: (state) => {
      state.isGetPatientLoading = true;
    },
    getPatientByIdSuccess: (state, action) => {
      state.singlePatientData = action.payload;
      state.isGetPatientLoading = false;
    },
    getPatientByIdFailure: (state) => {
      state.isGetPatientLoading = false;
    },
  },
});

export const {
  getPatientLoading,
  getPatientSuccess,
  getPatientFailure,
  updatePatientLoading,
  updatePatientSuccess,
  updatePatientFailure,
  getPatientByIdLoading,
  getPatientByIdSuccess,
  getPatientByIdFailure,
} = patientSlice.actions;

export default patientSlice.reducer;
